export const getProductListingInitialState = () => ({
    error: null,
    isLoading: false,
    requestId: '',
    responseId: '',
    facets: [],
    products: [],
    results: [],
});
